// Tooltip.tsx
import React from "react";
import { View, Text, StyleSheet, Image, ScrollView } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import { TouchableOpacity } from "react-native-gesture-handler";

type CreateEventTooltipProps = {
  content: any;
  visible: boolean;
  setVisible;
  width?: any;
  maxHeight?: number;
  right?: number;
  boxViewStyle?: any;
  closeBtnMargin?: number;
  closeImage?: any;
  bottom?: number;
  tooltipStyle?: any;
};

const CreateEventTooltip: React.FC<CreateEventTooltipProps> = ({
  content,
  visible,
  setVisible,
  width = "auto",
  maxHeight = 50,
  right = 40,
  boxViewStyle = {},
  closeBtnMargin = 10,
  bottom = 0,
  closeImage = AppImages.icCloseWhite,
  tooltipStyle,
}) => {
  if (!visible) return null;

  return (
    <View
      style={[
        styles.tooltipContainer,
        tooltipStyle,
        {
          width: width,
          right: right,
          bottom: bottom,
          zIndex: 2000,
        },
      ]}
    >
      <View style={styles.tooltip}>
        <TouchableOpacity
          onPress={() => {
            setVisible(false);
          }}
          style={{ alignItems: "flex-end" }}
        >
          <Image
            source={closeImage}
            style={{
              height: 16,
              width: 16,
              marginBottom: closeBtnMargin,
            }}
          />
        </TouchableOpacity>
        <View style={[styles.defaultBoxViewStyle, boxViewStyle]}>
          <ScrollView
            style={{ maxHeight: maxHeight }}
            showsVerticalScrollIndicator={false}
          >
            <Text style={styles.tooltipText}>{content}</Text>
          </ScrollView>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  defaultBoxViewStyle: {
    borderWidth: 1,
    borderColor: AppColors.white,
    padding: 10,
    maxHeight: 250,
  },
  tooltipContainer: {
    position: "absolute",
    bottom: 30,
    zIndex: 1000,
    alignItems: "center",
  },
  tooltip: {
    padding: 10,
    borderRadius: 5,
    backgroundColor: AppColors.appBlueColor_3A5175,
  },
  tooltipText: {
    color: "white",
  },
});

export default CreateEventTooltip;
